import React, { createContext, useContext, useState, useEffect } from "react";
import { LANGUAGES, t as tFn } from "./i18n";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => {
        return localStorage.getItem("vivoz_lang") || "es";
    });

    useEffect(() => {
        localStorage.setItem("vivoz_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const t = (path) => tFn(lang, path);

    return (
        <LangCtx.Provider value={{ lang, setLang, t, LANGUAGES }}>
            {children}
        </LangCtx.Provider>
    );
}

export const useLang = () => useContext(LangCtx);
